import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/pages/home/home.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { FormulaireComponent } from './components/pages/formulaire/formulaire.component';
import { AutomobileComponent } from './components/pages/automobile/automobile.component';
import { ActivateAccountComponent } from './components/pages/activation-account/activation-account.component';
import { VoyageComponent } from './components/pages/voyage/voyage.component';
import { SanteComponent } from './components/pages/sante/sante.component';
import { MrhComponent } from './components/pages/mrh/mrh.component';
import { MrpComponent } from './components/pages/mrp/mrp.component';
import { IndividuelleAccidentComponent } from './components/pages/individuelle-accident/individuelle-accident.component';
import { RceComponent } from './components/pages/rce/rce.component';
import { StockMarchandisesComponent } from './components/pages/stock/stock.component';
import { FlotteComponent } from './components/pages/flotte/flotte.component';
import { EducationComponent } from './components/pages/education/education.component';
import { RetraiteComponent } from './components/pages/retraite/retraite.component';
import { DecesComponent } from './components/pages/deces/deces.component';

const routes: Routes = [
  {
    path:'',component:HomeComponent
  },
  {
    path:'auto-mono', component: AutomobileComponent
  },
  {
    path:'auto-flotte', component: FlotteComponent
  },
  {
    path:'auto', component: FormulaireComponent
  },
  {
    path:'vie',component: FormulaireComponent
  },
  {
    path:'prevoyance-deces',component: DecesComponent
  },
  {
    path:'prevoyance-retraite',component: RetraiteComponent
  },
  {
    path:'prevoyance-education',component: EducationComponent
  },
  //  {
  //   path:'sante',component: FormulaireComponent
  // },
  {
    path:'sante',component: SanteComponent
  },
  // {
  //   path:'accident-individuel',component: FormulaireComponent
  // },
  {
    path:'accident-individuel',component: IndividuelleAccidentComponent
  },
  // {
  //   path:'stock-marchandises',component: FormulaireComponent
  // },
  {
    path:'multirisque',component: FormulaireComponent
  },
  // {
  //   path:'multirisque-pro',component: FormulaireComponent
  // },
   {
    path:'multirisque-pro',component: MrpComponent
  },
  // {
  //   path:'multirisque-habitat',component: FormulaireComponent
  // },
  {
    path:'multirisque-habitat',component: MrhComponent
  },
  // {
  //   path:'voyage',component: FormulaireComponent
  // },
   {
    path:'voyage',component: VoyageComponent
  },
  {
    path:'activate-account',component: ActivateAccountComponent
  },
  {
    path:'responsable-civile-entreprise',component: RceComponent
  },
  {
    path:'stock-marchandises',component: StockMarchandisesComponent
  },
  {
    path:'**',component:ErrorComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
